import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.small";
import "core-js/modules/es6.string.bold";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
/**
 * Deprecated. Use <Type> instead.
 *
 * @deprecated
 */

var Text = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      _props$bold = props.bold,
      bold = _props$bold === void 0 ? false : _props$bold,
      italic = props.italic,
      _props$uppercase = props.uppercase,
      uppercase = _props$uppercase === void 0 ? false : _props$uppercase,
      _props$small = props.small,
      small = _props$small === void 0 ? false : _props$small,
      color = props.color,
      component = props.component,
      className = props.className,
      otherProps = _objectWithoutProperties(props, ["children", "inline", "bold", "italic", "uppercase", "small", "color", "component", "className"]);

  var allClassName = classNames([className, classes(_defineProperty({
    'text-default': !small,
    'text-small': small,
    uppercase: uppercase,
    bold: bold,
    italic: italic
  }, "color-".concat(color), color))]);
  var Component = component || (inline ? 'span' : 'p');
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: allClassName,
    ref: ref
  }, otherProps), children);
});
Text.displayName = 'Text';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Text.propTypes = {
    /** Text or other inline children */
    children: PropTypes.node,

    /**
     * By default <Text> is block-level (renders a <p> tag). If the inline prop
     * is used, <Text> is inline (renders a <span> tag).
     */
    inline: PropTypes.bool,

    /** Bold styling */
    bold: PropTypes.bool,

    /** Italic styling */
    italic: PropTypes.bool,

    /**
     * Use the smaller of the two font sizes. By default, the larger is used.
     */
    small: PropTypes.bool,

    /** Turn text uppercase and spaces out letters. * */
    uppercase: PropTypes.bool,

    /* Set text to a color defined by base-styles */
    color: PropTypes.string,

    /**
     * Use a custom component instead of the default 'p' (block) and 'span'
     * (inline) html components.
     */
    // eslint-disable-next-line react/forbid-prop-types
    component: PropTypes.any,
    className: PropTypes.string
  };
}

export default Text;